import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Overview',
      href: '/en/Indoor_Cameras/IN-8001_HD/',
    },
    {
      text: 'Specifications',
      href: '/en/Indoor_Cameras/IN-8001_HD/Technical_Specifications/',
    },
    {
      text: 'Features',
      href: '/en/Indoor_Cameras/IN-8001_HD/Product_Features/',
    },
    {
      text: 'Installation',
      href: '/en/Indoor_Cameras/IN-8001_HD/Quick_Installation/',
    },
    {
      text: 'Lense Adjustment',
      href: '/en/Indoor_Cameras/IN-8001_HD/Lense_Adjustment/',
    },
    {
      text: 'Usermanual',
      href: '/en/Indoor_Cameras/IN-8001_HD/Usermanual/',
    },
    {
      text: '◄ Indoor Cameras',
      href: '/en/Indoor_Cameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-8001 Full HD Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}